import React from "react";
import {useState} from "react";
import styled from "styled-components";
import 'bootstrap/dist/css/bootstrap.min.css';
import { FOCUSABLE_SELECTOR } from "@testing-library/user-event/dist/utils";


function Navbar(){

    const [menu, setMenu ] = useState( false )

    const toggleMenu = () => {
        setMenu( !menu )
    }

    return (
        <Navba>
            <header className="cabecera">
                <h1 className="cabecera-h1">
                    <a href="" className="cabecera-a">
                        <img src="./logo.png" className="logo-1"></img>
                    </a>
                </h1>
                <button className="button"  onClick={ toggleMenu }>
                    <i className="cabecera-svg" class="bi bi-list"></i>
                </button>
                <nav className={ `cabecera-nav ${ menu ? 'isActive' : '' }`}>
                    <ul className="cabecera-ul" >
                        <li className="cabecera-li"><a href="#Inicio">Inicio</a></li>
                        <li className="cabecera-li"><a href="#Servicios">Servicios</a></li>
                        <li className="cabecera-li"><a href="#Modo-pc">Modo-pc</a></li>
                        <li className="cabecera-li"><a href="#Galeria">Galeria</a></li>
                        <li className="cabecera-li"><a href="#Contactos">Contacto</a></li>
                    </ul>
                </nav>
            </header>
        </Navba>
    );
} 


export default Navbar; 

const Navba = styled.div`

.cabecera {
    background: white;
    padding: 1em;

    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;

}


.cabecera-h1 {

}

.cabecera-a {

}

.logo-1 {
    width: 120px;

}

.cabecera-nav {

}


.cabecera-ul {
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    

}

.cabecera-li {
    margin: 40px 50px;
    text-decoration: none;
    list-style: none;
    font-size: 20px;

}

.cabecera-li a {
    color: black;
    text-decoration: none;
}

.cabecera-svg {
    padding: 20px;
}


.button {
    margin: 35px;
    width: 50px;
    height: 50px;
    display: none;
}


@media screen and (max-width: 567px){
    .button {
        display: flex;
        width: 9%;
        height: 7%;
    }

    .button i {
        width: 100%;
    }

    .cabecera-nav {
        width: 100%;
        height: 0vh;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        opacity: 0;
        transition: all 1s ease;
    }

    .cabecera-nav.isActive {
        height: 130vh;
        opacity: 1;
    }

    .cabecera-ul {
        flex-direction: column;
    
    }
}

`
